import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavSignoutIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M15.127 4.87305C15.4198 4.58018 15.8977 4.57813 16.162 4.89699C17.3101 6.28194 18 8.06052 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 8.06052 2.68989 6.28194 3.83796 4.89699C4.10228 4.57813 4.58018 4.58018 4.87305 4.87305C5.16591 5.16591 5.16199 5.63836 4.90461 5.96284C4.02504 7.07174 3.5 8.47469 3.5 10C3.5 13.5899 6.41015 16.5 10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 8.47469 15.975 7.07174 15.0954 5.96284C14.838 5.63836 14.8341 5.16591 15.127 4.87305Z"
          fill="inherit"
        />
        <path
          d="M10 2C10.4142 2 10.75 2.33579 10.75 2.75V8.25C10.75 8.66421 10.4142 9 10 9C9.58579 9 9.25 8.66421 9.25 8.25V2.75C9.25 2.33579 9.58579 2 10 2Z"
          fill="inherit"
        />
      </g>
    </SvgWrapper>
  );
}
